/**
 * Custom Product Page JavaScript - Shopify Dawn Theme
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Thumbnail Image & Video Switcher
  const mediaDisplay = document.getElementById('MainProductMediaDisplay') || document.querySelector('.product-featured-image');
  const thumbnails = document.querySelectorAll('.thumb-item');
  const thumbnailsTrack = document.getElementById('ThumbnailsTrack');
  const btnPrev = document.getElementById('ThumbSliderPrev');
  const btnNext = document.getElementById('ThumbSliderNext');

  if (mediaDisplay && thumbnails.length > 0) {
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbnails.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        const mediaType = thumb.getAttribute('data-media-type');
        const fullSrc = thumb.getAttribute('data-full-src');

        if (mediaType === 'video') {
          const videoUrl = thumb.getAttribute('data-video-url');
          const mimeType = thumb.getAttribute('data-mime-type') || 'video/mp4';
          mediaDisplay.innerHTML = `
            <video 
              class="product-video-player" 
              controls 
              autoplay 
              loop 
              playsinline 
              muted 
              poster="${fullSrc || ''}" 
              style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;"
            >
              <source src="${videoUrl}" type="${mimeType}">
              Your browser does not support video playback.
            </video>
          `;
          const videoEl = mediaDisplay.querySelector('video');
          if (videoEl) videoEl.play().catch(() => {});
        } else if (mediaType === 'external_video') {
          const extUrl = thumb.getAttribute('data-external-video-url');
          mediaDisplay.innerHTML = `
            <iframe 
              src="${extUrl}" 
              class="product-external-video-player" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen 
              style="width: 100%; height: 100%; min-height: 480px; border-radius: 8px;"
            ></iframe>
          `;
        } else {
          mediaDisplay.innerHTML = `
            <img 
              id="MainProductImage" 
              src="${fullSrc}" 
              alt="${thumb.querySelector('img')?.alt || 'Product Image'}" 
              loading="eager" 
              width="600" 
              height="800" 
              style="width: 100%; height: auto; border-radius: 8px; object-fit: cover;"
            >
          `;
        }

        // Scroll active thumbnail into view smoothly
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    });
  }

  // Thumbnail Slider Navigation Controls
  if (thumbnailsTrack) {
    const scrollAmount = 140;

    if (btnPrev) {
      btnPrev.addEventListener('click', () => {
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
          thumbnailsTrack.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        } else {
          thumbnailsTrack.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
        }
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', () => {
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
          thumbnailsTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        } else {
          thumbnailsTrack.scrollBy({ top: scrollAmount, behavior: 'smooth' });
        }
      });
    }
  }

  // 2. Dynamic Shopify Variant & Price Updating
  const variantsJsonEl = document.getElementById('ProductVariantsJson');
  let productVariants = [];
  if (variantsJsonEl) {
    try {
      const parsed = JSON.parse(variantsJsonEl.textContent);
      productVariants = Array.isArray(parsed) ? parsed : (parsed ? parsed.variants || [] : []);
    } catch (e) {
      console.error('Failed to parse ProductVariantsJson', e);
    }
  }

  function formatPrice(cents) {
    if (cents == null || isNaN(cents)) return '';
    let val = typeof cents === 'string' ? parseFloat(cents) : cents;
    let amount = val > 99999 ? Math.round(val / 100) : Math.round(val);
    return 'Rs. ' + amount.toLocaleString('en-IN');
  }

  function updateVariantState() {
    const optionRows = document.querySelectorAll('.color-swatches-row, .size-pills-row');
    const selectedValues = [];

    optionRows.forEach((row) => {
      const selectedItem = row.querySelector('.color-swatch-item.selected, .size-pill.selected');
      if (selectedItem) {
        const val = selectedItem.getAttribute('data-option-value') || selectedItem.getAttribute('data-size') || selectedItem.getAttribute('data-color');
        if (val) selectedValues.push(val.trim());
      }
    });

    if (selectedValues.length === 0 || productVariants.length === 0) return;

    const matchedVariant = productVariants.find(variant => {
      if (!variant.options || variant.options.length === 0) return false;
      return variant.options.every((optVal, i) => {
        return selectedValues[i] && selectedValues[i].toLowerCase() === optVal.trim().toLowerCase();
      });
    });

    if (matchedVariant) {
      const variantInput = document.getElementById('SelectedVariantId') || document.querySelector('#CustomProductForm input[name="id"]');
      if (variantInput) {
        variantInput.value = matchedVariant.id;
      }

      const priceContainer = document.querySelector('.product-price-block');
      if (priceContainer) {
        let currentPriceEl = priceContainer.querySelector('.current-price');
        let comparePriceEl = priceContainer.querySelector('.compare-price');
        let savingsPillEl = priceContainer.querySelector('.savings-pill');

        if (currentPriceEl) {
          currentPriceEl.textContent = formatPrice(matchedVariant.price);
        }

        const price = parseFloat(matchedVariant.price);
        const comparePrice = parseFloat(matchedVariant.compare_at_price);

        if (comparePrice && comparePrice > price) {
          if (!comparePriceEl) {
            comparePriceEl = document.createElement('span');
            comparePriceEl.className = 'compare-price';
            priceContainer.appendChild(comparePriceEl);
          }
          comparePriceEl.textContent = formatPrice(comparePrice);
          comparePriceEl.style.display = '';

          const savingsPct = Math.round(((comparePrice - price) / comparePrice) * 100);
          if (savingsPct > 0) {
            if (!savingsPillEl) {
              savingsPillEl = document.createElement('span');
              savingsPillEl.className = 'savings-pill';
              priceContainer.appendChild(savingsPillEl);
            }
            savingsPillEl.textContent = `Save ${savingsPct}%`;
            savingsPillEl.style.display = '';
          } else if (savingsPillEl) {
            savingsPillEl.style.display = 'none';
          }
        } else {
          if (comparePriceEl) comparePriceEl.style.display = 'none';
          if (savingsPillEl) savingsPillEl.style.display = 'none';
        }
      }

      const addToCartBtn = document.querySelector('.btn-add-to-cart');
      if (addToCartBtn) {
        if (matchedVariant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            ADD TO CART
          `;
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'SOLD OUT';
        }
      }

      if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
        const mainImage = document.getElementById('MainProductImage');
        if (mainImage) {
          mainImage.src = matchedVariant.featured_image.src;
        }
      }

      if (window.history && window.history.replaceState) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', newUrl.href);
      }
    }
  }

  // 3. Color Swatch Selector
  const colorSwatches = document.querySelectorAll('.color-swatch-item');
  const selectedColorInput = document.getElementById('SelectedColorInput');
  const selectedColorText = document.getElementById('SelectedColorText');

  if (colorSwatches.length > 0) {
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const parentRow = swatch.closest('.color-swatches-row');
        if (parentRow) {
          parentRow.querySelectorAll('.color-swatch-item').forEach(s => s.classList.remove('selected'));
        }
        swatch.classList.add('selected');

        const colorVal = swatch.getAttribute('data-option-value') || swatch.getAttribute('data-color');
        if (selectedColorInput) {
          selectedColorInput.value = colorVal;
        }
        if (selectedColorText) {
          selectedColorText.textContent = colorVal;
        }

        const optionHeader = parentRow ? parentRow.previousElementSibling : null;
        if (optionHeader) {
          const valLabel = optionHeader.querySelector('.selected-option-value');
          if (valLabel) valLabel.textContent = colorVal;
        }

        updateVariantState();
      });
    });
  }

  // 4. Size Pill Selector
  const sizePills = document.querySelectorAll('.size-pill');
  const selectedSizeInput = document.getElementById('SelectedSizeInput');
  const selectedSizeText = document.getElementById('SelectedSizeText');

  if (sizePills.length > 0) {
    sizePills.forEach(pill => {
      pill.addEventListener('click', () => {
        const parentRow = pill.closest('.size-pills-row');
        if (parentRow) {
          parentRow.querySelectorAll('.size-pill').forEach(p => p.classList.remove('selected'));
        }
        pill.classList.add('selected');

        const sizeVal = pill.getAttribute('data-option-value') || pill.getAttribute('data-size');
        if (selectedSizeInput) {
          selectedSizeInput.value = sizeVal;
        }
        if (selectedSizeText) {
          selectedSizeText.textContent = sizeVal;
        }

        const optionHeader = parentRow ? parentRow.previousElementSibling : null;
        if (optionHeader) {
          const valLabel = optionHeader.querySelector('.selected-option-value');
          if (valLabel) valLabel.textContent = sizeVal;
        }

        updateVariantState();
      });
    });
  }

  const urlParams = new URLSearchParams(window.location.search);
  const variantParam = urlParams.get('variant');
  if (variantParam && productVariants.length > 0) {
    const targetVariant = productVariants.find(v => String(v.id) === String(variantParam));
    if (targetVariant && targetVariant.options) {
      targetVariant.options.forEach((optVal, optIdx) => {
        const rows = document.querySelectorAll('.color-swatches-row, .size-pills-row');
        if (rows[optIdx]) {
          const matchingItem = Array.from(rows[optIdx].querySelectorAll('.color-swatch-item, .size-pill')).find(item => {
            const v = item.getAttribute('data-option-value') || item.getAttribute('data-size') || item.getAttribute('data-color');
            return v && v.trim().toLowerCase() === optVal.trim().toLowerCase();
          });
          if (matchingItem) {
            rows[optIdx].querySelectorAll('.color-swatch-item, .size-pill').forEach(el => el.classList.remove('selected'));
            matchingItem.classList.add('selected');

            const optionHeader = rows[optIdx].previousElementSibling;
            if (optionHeader) {
              const valLabel = optionHeader.querySelector('.selected-option-value');
              if (valLabel) valLabel.textContent = optVal;
            }
          }
        }
      });
    }
  }

  updateVariantState();

  // 5. Quantity Stepper (Fixed to 1 for Unique 1-of-a-kind Products)
  const qtyInput = document.getElementById('QuantityInput');
  const btnMinus = document.getElementById('QtyMinus');
  const btnPlus = document.getElementById('QtyPlus');

  if (qtyInput) {
    qtyInput.value = 1;
    qtyInput.setAttribute('max', '1');
    qtyInput.setAttribute('readonly', 'true');
  }

  if (btnMinus && btnPlus) {
    btnMinus.addEventListener('click', () => {
      if (qtyInput) qtyInput.value = 1;
    });

    btnPlus.disabled = true;
    btnPlus.style.opacity = '0.4';
    btnPlus.style.cursor = 'not-allowed';
    btnPlus.setAttribute('title', 'Unique 1-of-a-kind product (Only 1 available)');
  }

  // 6. Product Wishlist Toggle Action
  const productWishlistBtn = document.querySelector('.btn-wishlist, #ProductWishlistBtn');
  if (productWishlistBtn) {
    const getProductTitle = () => {
      const el = document.querySelector('.product-title-heading, h1.product__title, .product__title, .product-title');
      return el ? el.textContent.trim() : document.title;
    };
    const getProductPrice = () => {
      const el = document.querySelector('.product-price-block .current-price, .price-item--regular, .price__regular .price-item, .price');
      return el ? el.textContent.trim() : '';
    };
    const getProductImage = () => {
      const mainImage = document.getElementById('MainProductImage') || document.querySelector('.product__media img, .product-media img, img.product-featured-media');
      return mainImage ? mainImage.src : (document.querySelector('meta[property="og:image"]')?.content || '');
    };
    const getVariantId = () => {
      const variantInput = document.getElementById('SelectedVariantId') || document.querySelector('#CustomProductForm input[name="id"], form[action*="/cart/add"] input[name="id"]');
      return variantInput ? variantInput.value : '';
    };

    const checkWishlistStatus = () => {
      const pTitle = getProductTitle();
      const vId = getVariantId();
      const list = (typeof getStoredWishlist === 'function') ? getStoredWishlist() : JSON.parse(localStorage.getItem('winningkart_wishlist') || '[]');
      const isSaved = list.some(item => {
        const id = typeof item === 'string' ? item : (item.id || item.title);
        return id === pTitle || (vId && id === vId);
      });

      if (isSaved) {
        productWishlistBtn.classList.add('active');
        productWishlistBtn.innerHTML = '♥ Added to Wishlist';
      } else {
        productWishlistBtn.classList.remove('active');
        productWishlistBtn.innerHTML = '♡ Add to Wishlist';
      }
    };

    checkWishlistStatus();

    productWishlistBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const pTitle = getProductTitle();
      const pPrice = getProductPrice();
      const pImage = getProductImage();
      const pUrl = window.location.href;
      const vId = getVariantId();

      let list = (typeof getStoredWishlist === 'function') ? getStoredWishlist() : JSON.parse(localStorage.getItem('winningkart_wishlist') || '[]');
      const isSaved = list.some(item => {
        const id = typeof item === 'string' ? item : (item.id || item.title);
        return id === pTitle || (vId && id === vId);
      });

      if (isSaved) {
        list = list.filter(item => {
          const id = typeof item === 'string' ? item : (item.id || item.title);
          return id !== pTitle && id !== vId;
        });
      } else {
        list.push({
          id: vId || pTitle,
          title: pTitle,
          price: pPrice,
          image: pImage,
          url: pUrl,
          variantId: vId
        });
      }

      if (typeof saveStoredWishlist === 'function') {
        saveStoredWishlist(list);
      } else {
        localStorage.setItem('winningkart_wishlist', JSON.stringify(list));
      }

      if (typeof updateWishlistUI === 'function') {
        updateWishlistUI();
      }

      checkWishlistStatus();

      if (!isSaved) {
        if (typeof renderWishlistDrawer === 'function') {
          renderWishlistDrawer();
        }
        const wishlistDrawer = document.getElementById('WishlistDrawer');
        const wishlistOverlay = document.getElementById('WishlistDrawerOverlay');
        if (wishlistDrawer) wishlistDrawer.classList.add('is-active');
        if (wishlistOverlay) wishlistOverlay.classList.add('is-active');
      }
    });
  }

  // 7. Product Form Add to Cart & Buy Now Action
  const customProductForm = document.getElementById('CustomProductForm');
  if (customProductForm) {
    customProductForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(customProductForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        window.location.href = '/cart';
      })
      .catch(err => {
        customProductForm.submit();
      });
    });

    const buyNowBtn = customProductForm.querySelector('.btn-buy-now');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', () => {
        const formData = new FormData(customProductForm);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(res => res.json())
        .then(data => {
          window.location.href = '/checkout';
        })
        .catch(err => {
          window.location.href = '/checkout';
        });
      });
    }
  }
});
